module.exports = __webpack_public_path__ + "media/images/features/4/album/main-2-ac51506a085b1c59e9c3318742dd295e.jpg";